<script lang="ts">
  export let width = '13';
  export let height = '12';
  export let fill = '#F8A038';
</script>

<svg
  {width}
  {height}
  viewBox="0 0 13 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.0703 6C12.0703 9.31371 9.38402 12 6.07031 12C2.7566 12 0.0703125 9.31371 0.0703125 6C0.0703125 2.68629 2.7566 0 6.07031 0C9.38402 0 12.0703 2.68629 12.0703 6ZM4.07031 5C3.51803 5 3.07031 5.44772 3.07031 6C3.07031 6.55228 3.51803 7 4.07031 7H8.07031C8.6226 7 9.07031 6.55228 9.07031 6C9.07031 5.44772 8.6226 5 8.07031 5H4.07031Z"
    fill={fill}
  />
</svg>
